import styled from "styled-components";

export const HomeContainer = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
`;
